module.exports = __webpack_public_path__ + "static/media/lobby.97115ec0.mp3";